module.exports = new __parcel__URL__("ww-animated-editorial-packages.1abb1426.gif").toString();